import React, { useEffect, useState } from "react";
import "./CreateNewQB.css";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import axios from "../../../axios";
import CreateQuestion from "../../../Components/QuestionEditCreate/CreateQuestion";
import ComponentType from "../../../Enum/ComponentTypeEnum";
import { FormControl, Select, MenuItem } from "@mui/material";

export default function CreateNewQB({ componentType, leftSidebarSize }) {
  const navigate = useNavigate();
  const CTRole_Information = JSON.parse(
    localStorage.getItem("role_as_class_teacher"),
  );
  const CoRole_Information = JSON.parse(
    localStorage.getItem("role_as_co_ordinator"),
  );
  const general_role = JSON.parse(localStorage.getItem("general_role"));
  const standardList = [];
  const sectionList = [];
  const subjectList = [];
  const [dropdownLists, setDropdownLists] = useState({
    standards: null,
    sections: null,
    subjects: null,
  });
  const [nameOfQB, setQBName] = useState("");
  const [specialChar, setSpecialChar] = useState(false);
  const [click, setClick] = useState(false);
  const { standards, sections, subjects } = dropdownLists;

  const [assessmentDetails, setAssessmentDetails] = useState({
    name: "",
    description: "",
    teacher_id: null,
    type_id: "",
    standard_id: { id: "", name: "" },
    section_id: { id: "", name: "" },
    subject_id: { id: "", name: "" },
    tags: [],
    status: null,
    total_duration: null,
    schedule_date: null,
    schedule_time: null,
    add_to_live_session: { lecture_id: null, date: null },
    questions: [],
  });

  const initialAssessmentDetails = {
    name: "",
    description: "",
    teacher_id: null,
    type_id: "",
    standard_id: { id: "", name: "" },
    section_id: { id: "", name: "" },
    subject_id: { id: "", name: "" },
    tags: [],
    status: null,
    total_duration: null,
    schedule_date: null,
    schedule_time: null,
    add_to_live_session: { lecture_id: null, date: null },
    questions: [],
  };

  useEffect(() => {
    if (!assessmentDetails) return;

    const timer = setTimeout(() => {
      const prev = JSON.parse(
        localStorage.getItem("temp_Questions_QUESTION_BANK") || "null",
      );

      if (
        !prev &&
        JSON.stringify(assessmentDetails) ===
          JSON.stringify(initialAssessmentDetails)
      ) {
        return;
      }

      if (
        prev?.questionBankData &&
        JSON.stringify(prev?.questionBankData) ===
          JSON.stringify(assessmentDetails)
      ) {
        return;
      }

      if (prev) {
        localStorage.setItem(
          "temp_Questions_QUESTION_BANK",
          JSON.stringify({
            questionBankData: assessmentDetails,
            questions: prev?.questions,
          }),
        );
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [assessmentDetails]);

  useEffect(() => {
    const saved = JSON.parse(
      localStorage.getItem("temp_Questions_QUESTION_BANK"),
    );

    if (saved && saved?.questions?.length > 0) {
      setAssessmentDetails(saved.questionBankData);
    }
  }, []);

  useEffect(() => {
    if (CTRole_Information && CTRole_Information.length > 0) {
      CTRole_Information?.forEach((obj) => {
        if (!standardList.some((i) => i.id === obj.standard_id.id)) {
          standardList.push(obj.standard_id);
        }
        if (!sectionList.some((i) => i.id === obj.section_id.id)) {
          sectionList.push(obj.section_id);
        }
        let subjects = obj.subjects_id;
        if (subjects.length > 0) {
          for (const subject of subjects) {
            if (!subjectList.some((i) => i.id === subject.id)) {
              subjectList.push({ id: subject.id, name: subject.name });
            }
          }
        }
      });
    }
    if (CoRole_Information && CoRole_Information.length > 0) {
      CoRole_Information?.forEach((obj) => {
        if (!standardList.some((i) => i.id === obj.standard_id.id)) {
          standardList.push(obj.standard_id);
        }
        if (!sectionList.some((i) => i.id === obj.section_id.id)) {
          sectionList.push(obj.section_id);
        }
        let subjects = obj.subjects_id;
        if (subjects.length > 0) {
          for (const subject of subjects) {
            if (!subjectList.some((i) => i.id === subject.id)) {
              subjectList.push({ id: subject.id, name: subject.name });
            }
          }
        }
      });
    }
    if (general_role && general_role.length > 0) {
      general_role?.forEach((obj) => {
        if (!standardList.some((i) => i.id === obj.standard_id.id)) {
          standardList.push(obj.standard_id);
        }
        if (!sectionList.some((i) => i.id === obj.section_id.id)) {
          sectionList.push(obj.section_id);
        }
        let subjects = obj.subjects_id;
        if (subjects.length > 0) {
          for (const subject of subjects) {
            if (!subjectList.some((i) => i.id === subject.id)) {
              subjectList.push({ id: subject.id, name: subject.name });
            }
          }
        }
      });
    }
    standardList.length > 0 &&
      setDropdownLists((prev) => ({ ...prev, standards: standardList }));

    sectionList.length > 0 &&
      setDropdownLists((prev) => ({ ...prev, sections: sectionList }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSubjects = async (standard_id, section_id) => {
    let arrSubject = [];
    try {
      let res = await axios.get(
        `/api/v1/school/standardId/${standard_id}/sectionId/${section_id}/getSubjects`,
      );

      const data = res?.data?.data;

      const subjectSource =
        data?.subjectConfigurations?.length > 0
          ? data.subjectConfigurations.map((item) => item.subject)
          : data.subjects;

      subjectSource.forEach((obj) => {
        arrSubject.push(obj);
      });
    } catch (error) {
      console.log(error);
    }
    return arrSubject;
  };

  useEffect(() => {
    (async () => {
      let subjects = [];
      if (
        ((CTRole_Information && CTRole_Information.length > 0) ||
          (CoRole_Information && CoRole_Information.length > 0)) &&
        assessmentDetails.standard_id?.id !== "null" &&
        assessmentDetails.section_id?.id !== "null"
      ) {
        subjects = await getSubjects(
          assessmentDetails.standard_id?.id,
          assessmentDetails.section_id?.id,
        );
      }
      if (CTRole_Information && CTRole_Information.length > 0) {
        CTRole_Information?.forEach(async (obj) => {
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (CoRole_Information && CoRole_Information.length > 0) {
        CoRole_Information?.forEach(async (obj) => {
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            if (subjects.length > 0) {
              for (const subject of subjects) {
                if (!subjectList.some((i) => i.id === subject.id)) {
                  subjectList.push({ id: subject.id, name: subject.name });
                }
              }
            }
          }
        });
      }
      if (general_role && general_role.length > 0) {
        general_role?.forEach((obj) => {
          let subjects = obj.subjects_id;
          if (
            obj.standard_id.id === assessmentDetails.standard_id?.id &&
            obj.section_id.id === assessmentDetails.section_id?.id
          ) {
            for (const subject of subjects) {
              if (!subjectList.some((i) => i.id === subject.id)) {
                subjectList.push({ id: subject.id, name: subject.name });
              }
            }
          }
        });
      }
      subjectList.length > 0 &&
        setDropdownLists((prev) => ({ ...prev, subjects: subjectList }));
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentDetails.standard_id, assessmentDetails.section_id]);

  const isDisabled =
    !assessmentDetails.name.trim() ||
    !assessmentDetails.standard_id?.id ||
    !assessmentDetails.section_id?.id ||
    !assessmentDetails.subject_id?.id ||
    assessmentDetails.subject_id?.id === "null" ||
    assessmentDetails.section_id?.id === null;

  return (
    <>
      {!click && (
        // 👈 Pura area white background banaya
        <div
          style={{
            backgroundColor: "#fff",
            minHeight: "100%", // Screen bhar lega
            padding: "32px 40px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Top Breadcrumb / Back */}
          <div className="d-flex align-items-center gap-3 mb-5">
            <div
              onClick={() => navigate("/questionLibrary")}
              className="d-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "40px",
                height: "40px",
                backgroundColor: "#FFF1E6",
                color: "#F28C28",
                fontSize: "20px",
                fontWeight: "600",
                cursor: "pointer",
                flexShrink: 0,
              }}
            >
              <IoIosArrowBack />
            </div>
            <div
              className="d-flex flex-column"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/questionLibrary")}
            >
              <span style={{ fontSize: "18px", fontWeight: 700, color: "#1f2937" }}>
                Question Bank Setup
              </span>
              <span style={{ fontSize: "13px", color: "#6B7280" }}>
                Dashboard / Question Bank / Create New
              </span>
            </div>
          </div>

          {/* Form Container - Full Width, No maxWidth restriction */}
          <div
            style={{
              maxWidth: "1000px", // Thoda wide kiya taaki daba hua na lage
              width: "100%",
              margin: "0 auto",
            }}
          >
            <h3
              style={{
                fontSize: "24px",
                fontWeight: 700,
                color: "#111827",
                marginBottom: "32px",
              }}
            >
              Enter Question Bank Name
            </h3>

            {/* Name Input */}
            <div className="mb-4">
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: 600,
                  color: "#374151",
                  marginBottom: "8px",
                  display: "block",
                }}
              >
                Name
              </label>
              <input
                className="form-control"
                style={{
                  padding: "12px 16px",
                  borderRadius: "8px",
                  border: "1px solid #D1D5DB",
                  fontSize: "15px",
                  backgroundColor: "#F9FAFB",
                }}
                placeholder="e.g., Mathematics Practice Set 1"
                onChange={(e) => {
                  const value = e.target.value;
                  setQBName(value);
                  setAssessmentDetails({
                    ...assessmentDetails,
                    name: value,
                  });
                  setSpecialChar(false);
                }}
                value={assessmentDetails.name}
                maxLength={50}
              />
              {specialChar && (
                <p style={{ color: "#DC2626", fontSize: "12px", marginTop: "4px" }}>
                  *Special Character Not Allowed.
                </p>
              )}
            </div>

            {/* Dropdowns Row - Equal Spacing */}
            <div className="row g-4 mb-5">
              {/* Class Select */}
              <div className="col-md-4">
                <label
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#374151",
                    marginBottom: "8px",
                    display: "block",
                  }}
                >
                  Select Class
                </label>
                <FormControl size="medium" fullWidth>
                  <Select
                    value={assessmentDetails.standard_id.id || ""}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selected = standards.find((s) => s.id === selectedId);
                      setAssessmentDetails({
                        ...assessmentDetails,
                        standard_id: { id: selectedId, name: selected?.name || "null" },
                        subject_id: { id: "null", name: "null" },
                        section_id: { id: "null", name: "null" },
                      });
                    }}
                    displayEmpty
                    style={{ backgroundColor: "#F9FAFB", borderRadius: "8px" }}
                  >
                    <MenuItem value="" disabled>Select Class</MenuItem>
                    {standards?.length > 0 &&
                      [...standards]
                        .sort((a, b) => {
                          const aNum = Number(a.name);
                          const bNum = Number(b.name);
                          const bothNumeric = !isNaN(aNum) && !isNaN(bNum);
                          if (bothNumeric) return aNum - bNum;
                          return a.name.localeCompare(b.name);
                        })
                        .map((standard, index) => (
                          <MenuItem key={index} value={standard?.id} name={standard?.name}>
                            {standard?.name}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
              </div>

              {/* Section Select */}
              <div className="col-md-4">
                <label
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#374151",
                    marginBottom: "8px",
                    display: "block",
                  }}
                >
                  Select Section
                </label>
                <FormControl size="medium" fullWidth>
                  <Select
                    value={assessmentDetails.section_id.id || ""}
                    disabled={
                      assessmentDetails.standard_id.id === "null" ||
                      !assessmentDetails.standard_id.id
                    }
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selected = sections.find((s) => s.id === selectedId);
                      setAssessmentDetails({
                        ...assessmentDetails,
                        section_id: { id: selectedId, name: selected?.name || "null" },
                        subject_id: { id: "null", name: "null" },
                      });
                    }}
                    displayEmpty
                    style={{ backgroundColor: "#F9FAFB", borderRadius: "8px" }}
                  >
                    <MenuItem value="" disabled>Select Section</MenuItem>
                    {assessmentDetails.standard_id.id !== "null" &&
                      sections
                        ?.slice()
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((section, index) => (
                          <MenuItem key={index} value={section.id}>
                            {section.name}
                          </MenuItem>
                        ))}
                  </Select>
                </FormControl>
              </div>

              {/* Subject Select */}
              <div className="col-md-4">
                <label
                  style={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#374151",
                    marginBottom: "8px",
                    display: "block",
                  }}
                >
                  Select Subject
                </label>
                <FormControl size="medium" fullWidth>
                  <Select
                    value={assessmentDetails.subject_id.id || ""}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selected = subjects.find((s) => s.id === selectedId);
                      setAssessmentDetails({
                        ...assessmentDetails,
                        subject_id: { id: selectedId, name: selected?.name || "null" },
                      });
                    }}
                    disabled={
                      assessmentDetails.standard_id.id === "null" ||
                      assessmentDetails.section_id.id === "null" ||
                      !assessmentDetails.standard_id.id ||
                      !assessmentDetails.section_id.id
                    }
                    displayEmpty
                    style={{ backgroundColor: "#F9FAFB", borderRadius: "8px" }}
                  >
                    <MenuItem value="" disabled>Select Subject</MenuItem>
                    {assessmentDetails.standard_id.id !== "null" &&
                      assessmentDetails.section_id.id !== "null" &&
                      subjects?.map((subject, index) => (
                        <MenuItem key={index} value={subject.id}>
                          {subject.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
            </div>

            {/* Action Button */}
            <div className="d-flex justify-content-end mt-4">
              <button
                onClick={() => setClick(true)}
                disabled={isDisabled}
                style={{
                  padding: "12px 28px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: isDisabled ? "#FCD34D" : "#F28C28",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "15px",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  boxShadow: isDisabled ? "none" : "0 4px 6px rgba(242, 140, 40, 0.2)",
                  transition: "all 0.2s",
                }}
              >
                Next →
              </button>
            </div>
          </div>
        </div>
      )}

      {click && (
        <CreateQuestion
          componentType={ComponentType.QUESTION_BANK}
          setClickFromCreate={setClick}
          assessmentDetails={assessmentDetails}
          setAssessmentDetails={setAssessmentDetails}
          leftSidebarSize={leftSidebarSize}
        />
      )}
    </>
  );
}